export function SetCnList(data) {
  return {
    type: 'CN_LIST',
    cnList: data || [],
  };
}
